module.exports = __webpack_public_path__ + "HelveticaBold.3a284ba0f7d7c954efaf.eot";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/Helvetica/HelveticaBold.eot
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaBold.eot
// module chunks = styles